module.exports = __webpack_public_path__ + "media/images/athletes/4320-5fa9723c4b08c88e9d5c217df3937ead.png";